// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminSellers = (client) => ({
    /**
     * `POST /admin/sellers/invite`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminInviteSeller
     * @source packages/modules/b2c-core/src/api/admin/sellers/invite/route.ts
     */
    invite: (body, query, headers) => client.fetch("/admin/sellers/invite", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/sellers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSellers
     * @source packages/modules/b2c-core/src/api/admin/sellers/route.ts
     */
    list: (query, headers) => client.fetch("/admin/sellers", { method: "GET", query, headers }),
    /**
     * `GET /admin/sellers/:id/customer-groups`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSellerCustomerGroups
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/customer-groups/route.ts
     */
    listCustomerGroups: (id, query, headers) => client.fetch(buildPath("/admin/sellers/:id/customer-groups", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/sellers/:id/industries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSellerIndustries
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/industries/route.ts
     */
    listIndustries: (id, query, headers) => client.fetch(buildPath("/admin/sellers/:id/industries", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/sellers/:id/orders`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSellerOrders
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/orders/route.ts
     */
    listOrders: (id, query, headers) => client.fetch(buildPath("/admin/sellers/:id/orders", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/sellers/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListSellerProducts
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/admin/sellers/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/sellers/stats`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSellerStats
     * @source packages/modules/b2c-core/src/api/admin/sellers/stats/route.ts
     */
    listStats: (query, headers) => client.fetch("/admin/sellers/stats", { method: "GET", query, headers }),
    /**
     * `POST /admin/sellers/:id/reset-password`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminResetSellerPassword
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/reset-password/route.ts
     */
    resetPassword: (id, body, query, headers) => client.fetch(buildPath("/admin/sellers/:id/reset-password", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /admin/sellers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetSeller
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/sellers/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /admin/sellers/:id/industries`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSetSellerIndustries
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/industries/route.ts
     */
    setIndustries: (id, body, query, headers) => client.fetch(buildPath("/admin/sellers/:id/industries", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/sellers/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateSeller
     * @source packages/modules/b2c-core/src/api/admin/sellers/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/sellers/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=sellers.js.map